var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WordDisplay',{attrs:{"config":_vm.lyricConfig,"partNum":_vm.partNum},on:{"onRowClick":_vm.rowClickHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }